// -----------------------------------------------------------
// FloraIQ - OperationalReportsGrid (Aba Relatórios Operacionais)
// -----------------------------------------------------------

import { operationalReports } from "@/mocks/operational";

const reportStatusStyles: Record<string, string> = {
  "Gerado": "bg-green-100 text-green-700",
  "Em geração": "bg-accent-100 text-accent-700",
  "Em revisão": "bg-yellow-100 text-yellow-700",
  "Pendente": "bg-orange-100 text-orange-700",
};

export default function OperationalReportsGrid() {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {operationalReports.map((r) => (
          <div key={r.id} className="rounded-card border border-background-200/70 p-4 hover:border-primary-200 transition-colors">
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center">
                  <i className="ri-file-chart-line text-foreground-600 text-sm"></i>
                </div>
                <div>
                  <h5 className="text-sm font-bold text-foreground-900">{r.titulo}</h5>
                  <p className="text-[10px] text-foreground-400">Etapa: {r.etapaRelacionada}</p>
                </div>
              </div>
              <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap shrink-0 ${reportStatusStyles[r.status] || "bg-background-100 text-foreground-600"}`}>
                {r.status}
              </span>
            </div>
            <p className="text-xs text-foreground-500 mb-3">{r.descricao}</p>
            <div className="flex items-center justify-between">
              <span className="text-[10px] text-foreground-400">
                {r.ultimaGeracao !== "-" ? `Última geração: ${r.ultimaGeracao}` : "Nunca gerado"}
              </span>
              <div className="flex items-center gap-1.5">
                <button className="text-xs bg-primary-500 text-white px-2 py-1.5 rounded-md cursor-pointer whitespace-nowrap">
                  <i className="ri-play-line mr-1"></i>Gerar
                </button>
                <button className="text-xs bg-background-100 text-foreground-600 px-2 py-1.5 rounded-md cursor-pointer whitespace-nowrap hover:bg-background-200">
                  <i className="ri-eye-line"></i>
                </button>
                <button className="text-xs bg-background-100 text-foreground-600 px-2 py-1.5 rounded-md cursor-pointer whitespace-nowrap hover:bg-background-200">
                  <i className="ri-download-line"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}